
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "./staticJS/maelcorp-cookies.js";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Supprime ou commente cette ligne si tu n'as pas besoin de `web-vitals`
// import reportWebVitals from './reportWebVitals';
reportWebVitals();
